if (!customElements.get("faq-item")) {

class FaqItem extends HTMLElement {
  constructor() {
    super();
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.onClick = this.onClick.bind(this);
    this.onGroupOpen = this.onGroupOpen.bind(this);
  }

  connectedCallback() {
    this.details = this.querySelector(".faq-item__details");
    this.summary = this.querySelector(".faq-item__summary-row");
    this.panel = this.querySelector(".faq-item__panel");
    if (!this.details || !this.summary || !this.panel) return;

    this.summary.addEventListener("click", this.onClick);

    if (this.dataset.closeOthers === "true" && this.dataset.group) {
      document.addEventListener("faq:opened", this.onGroupOpen);
    }
  }

  disconnectedCallback() {
    this.summary.removeEventListener("click", this.onClick);
    document.removeEventListener("faq:opened", this.onGroupOpen);
  }

  onGroupOpen(event) {
    if (
      event.detail.group === this.dataset.group &&
      event.detail.source !== this
    ) {
      this.shrink();
    }
  }

  onClick(event) {
    event.preventDefault();
    this.details.style.overflow = "hidden";

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  open() {
    this.details.style.height = this.details.offsetHeight + "px";
    this.details.open = true;

    window.requestAnimationFrame(() => this.expand());

    if (this.dataset.closeOthers === "true" && this.dataset.group) {
      document.dispatchEvent(
        new CustomEvent("faq:opened", {
          detail: { group: this.dataset.group, source: this },
        }),
      );
    }
  }

  shrink() {
    if (!this.details.open) return;
    this.isClosing = true;

    const startHeight = this.details.offsetHeight + "px";
    const endHeight = this.summary.offsetHeight + "px";

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: this.duration(), easing: this.easing() },
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => {
      this.isClosing = false;
    };
  }

  expand() {
    this.isExpanding = true;

    const startHeight = this.details.offsetHeight + "px";
    const endHeight =
      this.summary.offsetHeight + this.panel.offsetHeight + "px";

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: this.duration(), easing: this.easing() },
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => {
      this.isExpanding = false;
    };
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = "";
    this.details.style.overflow = "";
  }

  duration() {
    return Number(this.dataset.duration) || 300;
  }

  easing() {
    return this.dataset.easing || "ease";
  }
}

customElements.define("faq-item", FaqItem);

}
